module.exports = __webpack_public_path__ + "img/diagram.1e5be27f.svg";